import type { Directive } from 'vue'


type EventDataValue = string | number | boolean | Date | null | undefined;
type EventData = Record<string, EventDataValue | EventDataValue[] | Record<string, EventDataValue>[]>;

export interface TrackDirectiveEventData {
  // prefix with v (v-track)
  event: string,
  eventData?: EventData,
}


export type TrackDirective = Directive<HTMLElement, string|TrackDirectiveEventData>

declare module 'vue' {
  export interface ComponentCustomProperties {
    // prefix with v (v-track)
    vTrack: TrackDirective
  }
}

export default {
  mounted: (el, binding) => {
    el.addEventListener('click', () => {
      if(binding.value){
        if(typeof binding.value === 'string'){
          useTrackStore().track(binding.value)
        }else{
          useTrackStore().track(binding.value.event,binding.value.eventData)
        }
      }
    })
  },
} satisfies TrackDirective
